import api from "../http-request";
import apiConstants from "../apiConstant";
// [GET] method
export const getListCampaignApi = async () =>
  api.get(`${apiConstants.CAMPAIGN.GET_LIST_CAMPAIGN}`);
export const getDetailCampaignApi = async (id) =>
  api.get(`${apiConstants.CAMPAIGN.GET_DETAIL_CAMPAIGN}/${id}`);
export const getSpaceSchedule = async (id) =>
  api.get(`api/admin/ts-campaign/schedule/${id}`);

// [POST] method
export const createNewCampaignApi = async (data) =>
  api.post("api/admin/ts-campaign/create", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const updateCampaignApi = async (id, data) =>
  api.post(`api/admin/ts-campaign/update/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
